var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"cus-link",attrs:{"to":'/dashboard/customers/' + _vm.id}},[(_vm.$slots.content)?_vm._t("content"):_c('span',[_vm._v(_vm._s(_vm.name))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }